import { CastMediaSession, CastSession, CastMediaStatus } from '../interfaces';
import { getChrome } from './getters';

export function getMedia(session: CastSession | undefined): CastMediaSession | undefined {
  const mediaSession = session?.getMediaSession();

  if (mediaSession) {
    return mediaSession as CastMediaSession;
  }

  return undefined;
}

export function mediaStatus(state: chrome.cast.media.PlayerState, prev: CastMediaStatus | undefined): CastMediaStatus {
  const chrome = getChrome();

  if (!chrome) {
    return 'idle';
  }

  switch (state) {
    case chrome.cast.media.PlayerState.IDLE:
      return 'idle';
    case chrome.cast.media.PlayerState.BUFFERING:
      return prev === 'idle' || prev === 'pending' ? 'loading' : 'buffering';
    case chrome.cast.media.PlayerState.PLAYING:
      return 'playing';
    case chrome.cast.media.PlayerState.PAUSED:
      return 'paused';
    default:
      return 'pending';
  }
}

export function getMediaStatus(
  media: CastMediaSession | chrome.cast.media.PlayerState | undefined,
  prev: CastMediaStatus | undefined,
): CastMediaStatus {
  if (!media) {
    return 'pending';
  }

  if (typeof media === 'object' && 'playerState' in media) {
    return media ? mediaStatus(media.playerState, prev) : 'pending';
  }

  return media ? mediaStatus(media, prev) : 'pending';
}
